import { BIO } from "@/data/content";

export default function Footer({ lang }) {
  return (
    <footer data-testid="footer" className="border-t border-[#7E2438]/25 bg-[#180F12] px-6 sm:px-12 md:px-20 py-12">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
        <p data-testid="footer-bio" className="max-w-xl text-sm leading-relaxed text-[#A89A9E]">
          {BIO[lang]}
        </p>
        <div className="flex items-center gap-4">
          <svg width="28" height="28" viewBox="0 0 34 34" aria-hidden="true">
            <rect width="34" height="34" rx="4" fill="#7E2438" />
            <text x="17" y="23" textAnchor="middle" fontFamily="'Playfair Display', serif" fontSize="15" fill="#F4EFEA" fontStyle="italic">PD</text>
          </svg>
          <span className="font-mono text-[11px] tracking-[0.25em] uppercase text-[#A89A9E]">© 2026</span>
        </div>
      </div>
    </footer>
  );
}
